import { reportException } from "./logs";

const isPendoEnabled = process.env.REACT_APP_PENDO_ENABLED === 'true';

const createPendoOnboardingData = (data: any) => {
    if (isPendoEnabled) {
        if (data != null) {
            const initialData = {
                visitor: {
                    id: data?.contactInfo?.email,
                    email: data?.contactInfo?.email,
                    visitorType: 'onboarding',
                    firstName: data?.contactInfo?.firstName,
                    lastName: data?.contactInfo?.lastName,
                    city: data?.contactInfo?.city,
                    state: data?.contactInfo?.state,
                    zipCode: data?.contactInfo?.zipCode,
                    address1: data?.contactInfo?.address1,
                    carrierId: data?.carrierInfo?.carrierId,
                    carrierName: data?.carrierInfo?.carrierName,
                    numberOfTrucks: data?.carrierInfo?.numberOfTrucks,
                    numberOfDrivers: data?.carrierInfo?.numberOfDrivers,
                    invitedDate: data?.statusInfo.invited,
                    invitationStatus: data?.statusInfo.status,
                },
                account: {
                    id: data?.invitationInfo.invitingUserEmail,
                    email: data?.invitationInfo.invitingUserEmail,
                    companyName: data?.invitationInfo.invitingCompanyName,
                    companyShortCode: data?.invitationInfo.companyShortCode,
                    companyId: data?.invitationInfo.invitingCompanyId,
                    firstName: data?.invitationInfo.invitingUserFirstName,
                    lastName: data?.invitationInfo.invitingUserLastName,
                    isInsurance: data?.invitationInfo.isInsurance,
                    canUseOAuth: data?.invitationInfo.canUseOAuth,
                }
            }
            initializePendo(initialData.visitor, initialData.account);
        }
    }
}
const createPendoLoginData = (isAuth: boolean) => {
    if (isPendoEnabled) {
        if (isAuth) {
            const initialData = {
                visitor: {
                    id: localStorage.getItem('userLogin'),
                    email: localStorage.getItem('userLogin'),
                    visitorType: 'dashboard',
                    userName: localStorage.getItem('userName'),
                    userId: localStorage.getItem('userId'),
                    userType: localStorage.getItem('userType'),
                    userTypeId: localStorage.getItem('userTypeId'),
                    isInsurance: localStorage.getItem('isInsurance'),
                    companyId: localStorage.getItem('companyId'),
                    companyName: localStorage.getItem('companyName'),
                    companyTypeId: localStorage.getItem('companyTypeId'),
                },
                account: {
                    id: localStorage.getItem('companyId'),
                    companyName: localStorage.getItem('companyName'),
                    companyTypeId: localStorage.getItem('companyTypeId'),
                }
            }
            initializePendo(initialData.visitor, initialData.account);
        }
    }
}

const createPendoWidgetData = (data: any) => {
    if (isPendoEnabled) {
        // Create anonymous visitor ID for widget users with readable date and time
        const now = new Date();
        const readableDate = now.toLocaleDateString('en-US').replace(/\//g, '-');
        const readableTime = now.toLocaleTimeString('en-US', { hour12: false, hour: '2-digit', minute: '2-digit' });
        const anonymousVisitorId = `widget_visitor_${data?.companyId || 'unknown'}_${readableDate}_${readableTime}`;

        const initialData = {
            visitor: {
                id: anonymousVisitorId,
                visitorType: 'widget form',
            },
            account: {
                id: data?.companyId,
                companyId: data?.companyId,
                email: data?.email,
            }
        }
        initializePendo(initialData.visitor, initialData.account);
    }
}

const initializePendo = (visitor: any, account: any) => {
    if (isPendoEnabled) {
        const pendoScript = (window as any).pendo;
        if (typeof pendoScript !== 'undefined') {
            if (!pendoScript.isReady()) {
                pendoScript.initialize({
                    visitor,
                    account,
                });
            }
            else {
                pendoScript.updateOptions({
                    visitor,
                    account,
                });
            }
        } else {
            console.error('Could not load Pendo');
            reportException('Could not load Pendo')
        }
    }
};

export { createPendoLoginData, createPendoOnboardingData, createPendoWidgetData, initializePendo }